import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

/**
 * Toasts.
 *
 * Colours live in index.css, not here. Sonner injects its own stylesheet at runtime and it lands
 * after ours, so the `group-[.toast]:text-*` utilities that used to sit on this component silently
 * lost to it - which is why the description text rendered in Sonner's default grey and read as
 * washed out. The rules in index.css use higher-specificity selectors and win cleanly.
 */
const Toaster = ({ ...props }) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "group toast",
          actionButton: "group-[.toast]:bg-[hsl(var(--rp-navy))] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-[hsl(var(--muted))] group-[.toast]:text-[hsl(var(--foreground))]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
